import styled from 'styled-components';

export const Thumbnail = styled.div.attrs({
  tabIndex: '0',
  className: 'Thumbnail',
})`
  height: 7.5rem;
  width: 7.5rem;
  margin: auto;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
`;
